import React, { Component } from 'react'
import { useApolloClient } from '@apollo/client'

import { graphql } from '@apollo/client/react/hoc'
import gql from 'graphql-tag'
import './MassMessageModal.css'
import { Row, Col, Alert, Progress, Label, Button, FormGroup, Input, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import Select from 'react-select'
import { TagsQuery } from "../Functions/querys"

import withApolloClient from '../withApolloClient'
import ConfirmationPopup from "./ConfirmationPopup"

const sendMessageMutation = gql`
mutation sendMessage($input: SendGeneralMessageMutationInput!){
  sendMessage(input:$input){
    ok
    selectedDriversCount
    isSent
    optedOutCustomers{
    id
    name
    phone
    }
    errors{
        messages
    }
  }
}`

const AllBranches = gql`query AllBranches{
    allBranches{
        edges{
            node{
                id
                customId
                name
            }
        }
    } 
}`

const AllFromContacts = gql`query AllFromContacts{
    allFromContacts{
        label
        type
        value
    } 
}`



class MassMessageModal extends Component {
    typingTimer = null;
    constructor(props) {
        super(props)
        this.state = {
            useCannedMessage: false,
            loading: false,
            error: null,
            messageSuccess: false,
            messageSubject: "",
            messageBody: "",
            stage: null,
            minBalance: 0,
            maxBalance: 0,
            minAgreements: 0,
            maxAgreements: 0,
            minActiveDays: 0,
            maxActiveDays: 0,
            selectedBranch: [],
            selectedGroupType: "",
            carStatus: null,
            isFilteredChecked: true,
            overrideMaxDrivers: false,
            tags: null,
            selectedDriversCount: 0,
            csvDriverIds: [],
            invalidDriverIds: [],
            isCsvUploadInfoOpen: false,
            hasDriverIdColumn: true,
            hasDataRows: true,
            fromPhone: null,
            selectedGroupTypeName: "",
            optedOutCustomers: []
        }
    }

    updateInput = (e) => {
        let name = e.target.name
        let value = e.target.value
        if (e.target.dataset.type && e.target.dataset.type === "boolean") {
            if (value === "false") {
                value = false
            } else {
                value = true
            }
        }
        if (e.target.type === "range" && typeof value === "string") {
            value = parseFloat(value)
        }
        this.setState({ [name]: value }, () => {
            if (name === "messageSubject" || name === "messageBody") {
                if (!this.props.drivers || this.props.drivers.length === 0) {
                    return;
                }
                clearTimeout(this.typingTimer);
                this.typingTimer = setTimeout(() => {
                    this.messageDrivers(false);
                }, 500);
            } else {
                this.messageDrivers(false);
            }
        })
    };

    handleClose = (e) => {
        let state = {
            useCannedMessage: false,
            loading: false,
            error: null,
            messageSuccess: false,
            messageBody: ""
        }
        this.setState({ ...state })
        this.props.handleClose()
    };

    getDriversCount = () => {
        if (this.state.loading) {
            return 'Loading...';
        }

        if (this.props.drivers?.length > 0) {
            return this.props.drivers.length;
        }

        return this.state.selectedDriversCount ?? 0;
    };

    componentDidMount() {
        const { apolloClient } = this.props
    }

    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "" })
        } else {
            this.setState({ openModal: modalName })
        }
    }

    handleSendMessageClick = () => {
        this.messageDrivers(false)
        this.toggleModal("sendMessageConfirmation")
    };

    messageDrivers = (confirmSend) => {
        // Prevent stale responses from affecting state
        this.currentRequestId = (this.currentRequestId || 0) + 1;
        const requestId = this.currentRequestId;
        try {
            this.setState({ loading: true })
            let input = {
                messageText: this.state.messageBody ? this.state.messageBody : "",
                messageSubject: this.state.messageSubject ? this.state.messageSubject : "",
                channel: "",
                overrideMaxDrivers: this.state.overrideMaxDrivers,
                confirmSend: confirmSend
            }
            if (this.state.csvDriverIds?.length > 0) {
                input["pks"] = this.state.csvDriverIds;
            } else if (this.props.drivers?.length > 0) {
                input["drivers"] = this.props.drivers ? this.props.drivers : []
            }
            if (this.state.tags) {
                input["tags"] = this.state.tags
            }
            if (this.state.selectedBranch && this.state.selectedBranch.length > 0) {
                input["branches"] = this.state.selectedBranch
            }
            if (this.state.stage) {
                input["stage"] = Number(this.state.stage)
            }
            if (this.state.carStatus) {
                input["carStatus"] = this.state.carStatus
            }
            if (this.state.selectedGroupTypeName === "WAV" || this.state.selectedGroupTypeName === "Non WAV") {
                input["isWav"] = this.state.selectedGroupType
            }
            if (this.state.minBalance) {
                input["minBalance"] = this.state.minBalance
            }
            if (this.state.maxBalance) {
                input["maxBalance"] = this.state.maxBalance
            }
            if (this.state.minAgreements) {
                input["minAgreementsCount"] = this.state.minAgreements
            }
            if (this.state.maxAgreements) {
                input["maxAgreementsCount"] = this.state.maxAgreements
            }
            if (this.state.minActiveDays) {
                input["minActiveDays"] = this.state.minActiveDays
            }
            if (this.state.maxActiveDays) {
                input["maxActiveDays"] = this.state.maxActiveDays
            }
            if (this.state.fromPhone) {
                input["fromPhone"] = this.state.fromPhone;
            }
            this.props.apolloClient.mutate({
                mutation: sendMessageMutation,
                variables: { input: input },
            }).then((result) => {
                if (requestId !== this.currentRequestId) return; // Ignore stale response
                if (result.data && result.data.sendMessage && result.data.sendMessage.ok) {
                    this.setState({ selectedDriversCount: result.data.sendMessage.selectedDriversCount, optedOutCustomers: result.data.sendMessage.optedOutCustomers || [], })
                    this.setState({ messageSuccess: true, error: null, loading: false })
                    if (confirmSend === true) {
                        this.setState({ messageSuccess: true, error: null, loading: false })
                    } else {
                        this.setState({ messageSuccess: false, error: null, loading: false })
                    }
                } else {
                    let error = "An error has occured. Please contact system admin"
                    if (result.data && result.data.sendMessage && result.data.sendMessage.errors && result.data.sendMessage.errors[0] && result.data.sendMessage.errors[0].messages[0]) {
                        error = result.data.sendMessage.errors[0].messages[0]
                    }
                    this.setState({ loading: false, messageSuccess: false, error: error })
                    this.setState({ selectedDriversCount: result.data.sendMessage.selectedDriversCount, optedOutCustomers: result.data.sendMessage.optedOutCustomers || [], })
                }
            }).catch((error) => {
                let errorMessage = "An error has occured: " + error
                this.setState({ error: errorMessage, loading: false, messageSuccess: false, })
            })
        } catch (err) {
            let errorMessage = "An error has occured: " + err
            this.setState({ error: errorMessage, loading: false, messageSuccess: false, })
        }
    };

    validateAndFilterDriverIds(lines) {
        const validDriverIds = [];
        const invalidEntries = [];
        const seen = new Set();

        lines.forEach(line => {
            const trimmed = line.trim();
            if (!trimmed || seen.has(trimmed)) return;

            const parsed = parseInt(trimmed, 10);
            if (!isNaN(parsed) && parsed > 0) {
                validDriverIds.push(parsed);
                seen.add(trimmed); // to avoid duplicates
            } else {
                invalidEntries.push(trimmed);
            }
        });
        this.setState({ invalidDriverIds: invalidEntries });
        return validDriverIds;
    }

    handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = (e) => {
            this.setState({
                invalidDriverIds: [],
                selectedDriversCount: 0,
                hasDriverIdColumn: true,
                csvDriverIds: [],
                hasDataRows: true
            });
            const fileContent = e.target.result;
            const rows = fileContent.split(/\r?\n/).map(line => line.split(",").map(cell => cell.trim()));

            if (rows.length < 2) {
                this.setState({ hasDataRows: false });
                return;
            }

            const header = rows[0];
            const driverIdIndex = header.findIndex(col => col.toLowerCase() === "driver_id");

            if (driverIdIndex === -1) {
                this.setState({ hasDriverIdColumn: false });
                return;
            }

            const rawIds = rows.slice(1).map(row => row[driverIdIndex]).filter(Boolean); // ignore empty
            if (rawIds.length === 0) {
                this.setState({ hasDataRows: false, csvDriverIds: [], selectedDriversCount: 0 });
                return;
            }
            const validDriverIds = this.validateAndFilterDriverIds(rawIds);

            this.setState({ csvDriverIds: validDriverIds }, () => {
                this.messageDrivers(false);
            });
        };
        reader.readAsText(file);
    };

    isAllSelectedDriverOptedOut = () => {
        const { drivers } = this.props;
        const { optedOutCustomers } = this.state;
        if (drivers?.length > 0 && optedOutCustomers?.length === drivers?.length) return true;
        return false;
    };

    render() {
        const allFromContacts = this.props?.allFromContacts?.filter(contact => contact.type === 'phone')
            .map(contact => ({
                value: contact.value,
                label: `${contact.label}: ${contact.value}`
            })) || [];

        return (
            <div>
                <Modal className="mass-message-modal" isOpen={this.props.open}>
                    <ModalHeader>
                        Send Mass Message
                    </ModalHeader>
                    <ModalBody>
                        {this.props.drivers && this.props.drivers.length > 0 ?
                            <Label className="text-success">
                                <strong>
                                    {this.state.messageSuccess ? "Message Sent To " : "Sending Message To "} {this.state.selectedDriversCount + (this.state.selectedDriversCount > 1 ? " Drivers" : " Driver")}
                                </strong>
                                <br />
                            </Label> :
                            <>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label for="selectedBranch">Filter By Branch</Label>
                                            <Select
                                                className="bos-custom-select"
                                                classNamePrefix="bos-select"
                                                options={this.props.allBranches && this.props.allBranches.edges && this.props.allBranches.edges.length > 0 && this.props.allBranches.edges.map(branch => ({ value: branch.node.name, label: branch.node.name }))}
                                                placeholder="SELECT BRANCH"
                                                onChange={(selected) => this.setState({ selectedBranch: selected ? selected.map(b => b.value) : [] }, () => {
                                                    this.messageDrivers(false)
                                                })}
                                                isMulti
                                                isClearable
                                                isDisabled={!this.state.isFilteredChecked}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label for="stage">Filter By Driver Stage</Label>
                                            <Select
                                                classNamePrefix="bos-select"
                                                className="bos-custom-select"
                                                name="stages"
                                                options={[{ value: "6", label: "Active" }, { value: "10", label: "Inactive", }, { value: "1", label: "Applied" }, { value: "0", label: "Didnt Take Car" }]}
                                                placeholder="SELECT STAGE"
                                                onChange={(filterStage) => this.setState({ stage: filterStage.value }, () => {
                                                    this.messageDrivers(false)
                                                })}
                                                isDisabled={!this.state.isFilteredChecked}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label for="stage">Filter By Driver Tag</Label>
                                            <Select
                                                classNamePrefix="bos-select"
                                                className="bos-custom-select"
                                                name="stages"
                                                options={this.props.driverTags && this.props.driverTags.edges && this.props.driverTags.edges.length > 0 ? this.props.driverTags.edges.map((tags) => ({ value: tags.node.name, label: tags.node.name })) : []}
                                                placeholder="SELECT DRIVER TAGS"
                                                isLoading={this.props.driverTagsLoading}
                                                isDisabled={!this.state.isFilteredChecked}
                                                isMulti isClearable
                                                onChange={tags => this.setState({ tags: tags && tags.length > 0 ? tags.map(item => item.value) : null }, () => {
                                                    this.messageDrivers(false)
                                                })}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label for="groupType">Is driver driving WAV/Non WAV Car?</Label>
                                            <Select
                                                className="bos-custom-select"
                                                classNamePrefix="bos-select"
                                                options={[{ value: true, label: "WAV" }, { value: false, label: "Non WAV" }]}
                                                placeholder="IS DRIVER WAV OR NON WAV"
                                                onChange={(group) => this.setState({ selectedGroupType: group.value, selectedGroupTypeName: group.label }, () => {
                                                    this.messageDrivers(false)
                                                })}
                                                isDisabled={!this.state.isFilteredChecked}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label>Filter By Car Status</Label>
                                            <Select
                                                classNamePrefix="bos-select"
                                                className="bos-custom-select"
                                                name="carStatus"
                                                options={[{ value: "Enabled", label: "Enabled" }, { value: "Disabled", label: "Disabled" }]}
                                                placeholder="SELECT CAR STATUS"
                                                onChange={(filterStatus) => this.setState({ carStatus: filterStatus.value }, () => {
                                                    this.messageDrivers(false)
                                                })}
                                                isDisabled={!this.state.isFilteredChecked}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label for="minBalance">Min Balance ${this.state.minBalance}</Label>
                                            <Input type="range" defaultValue={0} name="minBalance" id="balance" min="0" max="5000" step="10" onChange={this.updateInput} placeholder={"Min Balance $" + this.state.minBalance} disabled={!this.state.isFilteredChecked} />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label for="maxBalance">Max Balance ${this.state.maxBalance}</Label>
                                            <Input type="range" defaultValue={10000} name="maxBalance" id="balance" min={this.state?.minBalance && this.state.minBalance > 0 ? this.state.minBalance : 5000} max="10000" step="10" onChange={this.updateInput} placeholder={"Max Balance $" + this.state.maxBalance} disabled={!this.state.isFilteredChecked} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label for="minAgreements">Min Agreements {this.state.minAgreements}</Label>
                                            <Input type="range" defaultValue={0} name="minAgreements" id="minAgreements" min="0" max="500" step="5" onChange={this.updateInput} placeholder={"Min Balance $" + this.state.minAgreements} disabled={!this.state.isFilteredChecked} />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label for="maxAgreements">Max Agreements {this.state.maxAgreements}</Label>
                                            <Input type="range" name="maxAgreements" id="maxAgreements" defaultValue={1000} min={this.state?.minAgreements && this.state.minAgreements > 0 ? this.state.minAgreements : 500} max="1000" step="5" onChange={this.updateInput} placeholder={"Max Balance $" + this.state.maxAgreements} disabled={!this.state.isFilteredChecked} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <FormGroup>
                                            <Label for="minActiveDays">Min Active Days {this.state.minActiveDays}</Label>
                                            <Input type="range" defaultValue={0} name="minActiveDays" id="minActiveDays" min="0" max="5000" step="10" onChange={this.updateInput} placeholder={"Number Of Agreements " + this.state.minActiveDays} disabled={!this.state.isFilteredChecked} />
                                        </FormGroup>
                                    </Col>
                                    <Col>
                                        <FormGroup>
                                            <Label for="maxActiveDays">Max Active Days {this.state.maxActiveDays}</Label>
                                            <Input type="range" defaultValue={10000} name="maxActiveDays" id="maxActiveDays" min={this.state?.minActiveDays && this.state.minActiveDays > 0 ? this.state.minActiveDays : 5000} max="10000" step="10" onChange={this.updateInput} placeholder={"Total Active Days $" + this.state.maxActiveDays} disabled={!this.state.isFilteredChecked} />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                {this.state.selectedDriversCount > 250 &&
                                    <Row>
                                        <Col>
                                            <FormGroup>
                                                <Label>Override max message limit?<br />
                                                    <small>By default, there's a limit to how many drivers that can be messaged at once.</small>
                                                </Label>

                                                <br />
                                                <span>Yes</span>
                                                <div className="toggle-switch">
                                                    <input
                                                        type="checkbox"
                                                        className="toggle-switch-checkbox"
                                                        name="overrideMaxDrivers"
                                                        id="overrideMaxDrivers"
                                                        checked={!this.state.overrideMaxDrivers}
                                                        onChange={() => this.setState({ overrideMaxDrivers: !this.state.overrideMaxDrivers })}
                                                    />
                                                    <label className="toggle-switch-label" htmlFor="overrideMaxDrivers">
                                                        <span className="toggle-switch-inner" />
                                                        <span className="toggle-switch-switch" />
                                                    </label>
                                                </div>
                                                <span>No</span>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                }
                            </>}

                        {allFromContacts && allFromContacts.length > 0 &&
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label for="fromNumber">Send From Number</Label>
                                        <Select
                                            className="bos-custom-select"
                                            classNamePrefix="bos-select"
                                            placeholder="Select Number"
                                            isLoading={this.props.allFromContactsLoading}
                                            options={[{ label: 'Default', value: '' }, ...allFromContacts]}
                                            defaultValue={{ label: 'Default', value: '' }}
                                            isClearable
                                            isDisabled={this.props.allFromContactsLoading || (!allFromContacts?.length === 0)}
                                            onChange={(opt) => this.setState({ fromPhone: opt?.value })}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        }

                        {!this.state.messageSuccess &&
                            <Row>
                                <Col>
                                    <FormGroup>
                                        {/* <Label for="messageSubject">Message Subject</Label> */}
                                        <Input type="text" name="messageSubject" id="messageSubject" value={this.state.messageSubject} onChange={this.updateInput} placeholder="Enter the message subject" /><br />
                                        {/* <Label for="messageBody">Message to send</Label> */}
                                        <Input type="textarea" name="messageBody" id="messageBody" value={this.state.messageBody} onChange={this.updateInput} placeholder="Enter the message you'd like to send" rows={4} />
                                        <Row>
                                            <Col xs={12} className="pt-2">
                                                <p style={{ color: "grey" }}>
                                                    You can use following short_codes to add dynamic text.<br />
                                                    Driver Name: {"{name}"}, Balance: {"{balance}"}, Bad Debt Amount: {"{bad_debt_amount}"}<br /><br />
                                                    If you send: <strong>"Hello {"{name}"}, payfare paid {"{received_from_uber}"}, your balance is {"{balance}"}."</strong><br />
                                                    Driver will get: <strong>"Hello John Doe, payfare paid $0, your balance is $379."</strong>
                                                </p>
                                            </Col>
                                        </Row>
                                    </FormGroup>
                                </Col>
                            </Row>
                        }
                        <Row>
                            <Col>
                                <FormGroup>
                                    <Label for="driversCount" style={{ fontWeight: "800", color: "#28a745" }}>Selected Driver's Count {this.getDriversCount()}</Label>
                                    {this.state.invalidDriverIds.length > 0 &&
                                        <Alert color="warning" className="mt-2">
                                            <strong>{this.state.invalidDriverIds.length} invalid entr{this.state.invalidDriverIds.length === 1 ? "y was" : "ies were"} detected and will be ignored:</strong>
                                            <ul className="mb-0 mt-1">
                                                {this.state.invalidDriverIds.map((id, index) => (
                                                    <li key={index} style={{ fontSize: '0.9em' }}>{id}</li>
                                                ))}
                                            </ul>
                                        </Alert>
                                    }
                                    {!this.state.hasDriverIdColumn &&
                                        <Alert color="warning" className="mt-2">
                                            <strong>Missing <code>driver_id</code> column in the file.</strong><br />
                                            Please make sure your file has a header column labeled <code>driver_id</code> and try again.
                                        </Alert>
                                    }
                                    {!this.state.hasDataRows &&
                                        <Alert color="warning" className="mt-2">
                                            <strong>Missing driver ids for <code>driver_id</code> column in the file.</strong><br />
                                            Please make sure your file has data for the column labeled <code>driver_id</code> and try again.
                                        </Alert>
                                    }
                                    {this.state.optedOutCustomers?.length > 0 && (
                                        <Alert color="warning" className="mt-2">
                                            <strong>{this.isAllSelectedDriverOptedOut() ? "All selected drivers have opted out of our messaging service and will not receive this message:" : "The following drivers have opted out of our messaging service and will not receive this message:"}</strong>
                                            <ul className="mt-2 mb-0">
                                                {this.state.optedOutCustomers.map(driver => (
                                                    <li key={driver.id}>
                                                        <a className="bos-custom-link" href={`/driver/${driver.id}`} target="_blank" rel="noopener noreferrer">{driver?.name?.trim() ? driver.name : 'Unknown Driver'}</a>{' '}({driver.phone})
                                                    </li>
                                                ))}
                                            </ul>
                                        </Alert>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        {!this.state.loading &&
                            <div style={{ width: '100%' }}>
                                <Row className="align-items-center">
                                    <Col xs="6" className="text-start">
                                        {(!this.props.drivers || this.props.drivers.length === 0) &&
                                            <>
                                                <Button color="info" onClick={() => this.setState({ isCsvUploadInfoOpen: true })}>
                                                    Upload CSV or TXT
                                                </Button>
                                                <input
                                                    type="file"
                                                    accept=".csv,.txt"
                                                    ref={(ref) => (this.fileInputRef = ref)}
                                                    style={{ display: 'none' }}
                                                    onChange={this.handleFileUpload}
                                                />
                                            </>
                                        }
                                    </Col>
                                    <Col xs={6} className="text-right">
                                        <Button outline color="secondary" onClick={this.handleClose}>Close</Button>&nbsp;&nbsp;
                                        <Button id={"sendMessageConfirmation"} color="primary" onClick={this.handleSendMessageClick}
                                            disabled={
                                                !this.state.messageBody
                                                || this.state.messageSuccess
                                                || (!this.props.drivers?.length && this.state.selectedDriversCount === 0)
                                                || (this.state.selectedDriversCount > 250 && !this.state.overrideMaxDrivers)
                                                || this.state.loading
                                                || this.isAllSelectedDriverOptedOut()
                                            }>
                                            {this.state.loading ? "Processing..." : "Send Message"}
                                        </Button>&nbsp;&nbsp;
                                    </Col>
                                </Row>
                            </div>
                        }
                        {this.state.openModal === "sendMessageConfirmation" &&
                            <ConfirmationPopup
                                message={
                                    this.state.selectedDriversCount &&
                                        !this.state.error &&
                                        !this.state.messageSuccess
                                        ? `Are you sure you want to send the message to ${this.state.selectedDriversCount} driver${this.state.selectedDriversCount > 1 ? "s" : ""}?`
                                        : ""
                                }
                                open={this.state.openModal === "sendMessageConfirmation"}
                                confirmAction={() => this.messageDrivers(true)}
                                handleClose={() => this.toggleModal("")}
                                action="Ok"
                                color="primary"
                                loading={this.state.loading}
                                error={this.state.error ? this.state.error : ""}
                                success={this.state.messageSuccess ? "Message sent successfully!" : ""}
                            />
                        }
                        {this.state.isCsvUploadInfoOpen && (
                            <ConfirmationPopup
                                open={this.state.isCsvUploadInfoOpen}
                                handleClose={() => this.setState({ isCsvUploadInfoOpen: false })}
                                confirmAction={() => {
                                    this.setState({ isCsvUploadInfoOpen: false }, () => this.fileInputRef.click());
                                }}
                                message={
                                    <>
                                        <span><strong>Please upload a CSV or TXT file with a column named <code>driver_id</code>.</strong></span><br />
                                        <span>• Header row is required</span><br />
                                        <span>• Only values in the <code>driver_id</code> column will be processed</span><br />
                                        <span>• All other columns will be ignored</span>
                                    </>
                                }
                                action="Continue to Upload"
                                color="primary"
                            />
                        )}

                    </ModalFooter>
                </Modal>

            </div >
        )
    }
}


//-----------------------------------
const withAllFromContacts = graphql(AllFromContacts, {
    props: ({ data: { loading, allFromContacts } }) => ({
        allFromContactsLoading: loading,
        allFromContacts,
    })
});

export default graphql(AllBranches, {
    options: { fetchPolicy: 'cache-and-network' },
    props: ({ data: { loading, allBranches } }) => (
        { loading, allBranches }
    )
})(
    graphql(TagsQuery, {
        props: ({ data: { loading, driverTags } }) => (
            { driverTagsLoading: loading, driverTags }
        )
    })(
        withAllFromContacts(
            withApolloClient(MassMessageModal)
        )
    )
);

